import React from "react";
import "./assets/style/Hero.css";
import heroImage from "./assets/img/hero-team.jpg";

function Hero() {
  return (
    <section 
      id="hero" 
      className="d-flex align-items-center justify-content-center"
      style={{ backgroundImage: `url(${heroImage})` }}
      role="img"
      aria-label="Zespół Natchnienie Studio - zajęcia jogi, pilatesu i fitnessu w Gdańsku"
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-title">
          <div className="hero-brand">
            <span>NAT</span>
            <svg className="dot" viewBox="0 0 12 12">
              <circle cx="6" cy="6" r="5" fill="currentColor" />
            </svg>
            <span>chnienie</span>
          </div>
          <div className="hero-studio">Studio</div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
